var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g({ref:"input",staticClass:"ui-input-base-text",class:{
        _focused: _vm.isFocused,
        _disabled: _vm.isDisabled,
        _invalid: _vm.isInvalid,
        _phone: _vm.isPhone,
    },attrs:{"type":_vm.type,"placeholder":_vm.placeholder,"autofocus":_vm.isAutofocus,"disabled":_vm.isDisabled},domProps:{"value":_vm.valueFormatted},on:{"focus":_vm.focusHandler,"blur":_vm.blurHandler}},_vm.handler))}
var staticRenderFns = []

export { render, staticRenderFns }